export default __webpack_public_path__ + "static/media/b&a-woman-desk-last-above.c916b3bf.png";